// routes
import {PATH_APP} from './routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_API_URL || '';
export const WEBSOCKET_HOST = process.env.REACT_APP_API_HOST || '';
export const WEBSOCKET_PORT = process.env.REACT_APP_API_PORT || '';
export const PUSHER_CONFIG = (token) => {
    return {
        encrypted: false,
        cluster: "mt1",
        authEndpoint: 'https://' + WEBSOCKET_HOST + '/api/chatify/chat/auth',
        wsHost: WEBSOCKET_HOST,
        wsPort: WEBSOCKET_PORT,
        wssPort: WEBSOCKET_PORT,
        forceTLS: false,
        disableStats: true,
        auth: {
            headers: {
                Authorization: "Bearer " + token
            }
        }
    }
}
// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_APP.home; // as '/dashboard/app'

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
    MOBILE_HEIGHT: 64,
    MAIN_DESKTOP_HEIGHT: 88,
    DASHBOARD_DESKTOP_HEIGHT: 92,
    DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
    BASE_WIDTH: 260,
    DASHBOARD_WIDTH: 280,
    DASHBOARD_COLLAPSE_WIDTH: 88,
    //
    DASHBOARD_ITEM_ROOT_HEIGHT: 48,
    DASHBOARD_ITEM_SUB_HEIGHT: 40,
    DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

